import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_64bone32: FaireBrandEntity = {
  token: "b_64bone32",
  type: "brand",
  name: "Tiny Treasures Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/6f8752a51f19bdc23ae20de83a3ce4922f444da0d433af695a7b4fc42391f48b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/84388251a470fb5b517456a8381a803a1e55c87ad4ce8e6d4a81a805b536d2ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6f8752a51f19bdc23ae20de83a3ce4922f444da0d433af695a7b4fc42391f48b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/84388251a470fb5b517456a8381a803a1e55c87ad4ce8e6d4a81a805b536d2ba.jpeg",
  location: "Cincinnati, OH, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 102,
  isTopShop: true,
  isInsider: true,
  description:
    "I create unique items for babies, kids and families. Tiny Treasures was born with the birth of my second daughter and my desire to create handmade baby items for her.  In 2011, I left the corporate world to stay home with my girls and grow my company.  We are currently in over 350 shops and boutiques throughout the U.S. and internationally.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.031Z",
    importedBy: "entity-db-cli",
  },
};
